
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"30","height":"30"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h30v30H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M9.042 27.5l-1.74-1.75 8.575-8.656 4.349 4.375L26.656 15l1.771 1.781L20.226 25l-4.35-4.375L9.043 27.5zm-4.225-1.25a2.386 2.386 0 01-1.755-.734 2.414 2.414 0 01-.73-1.766V6.25c0-.688.243-1.276.73-1.766a2.386 2.386 0 011.755-.734h17.397c.684 0 1.269.245 1.755.734.487.49.73 1.079.73 1.766v5.25H4.817v14.75zm0-17.25h17.397V6.25H4.817V9z","fill":"#fff"}})])])
          )
        }
      }
    